import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadService } from '@certemy/ui-components';

@Component({
  selector: 'cm-attachments-popover',
  templateUrl: 'attachments-popover.component.html',
  styleUrls: ['attachments-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsPopoverComponent implements OnInit, OnDestroy {
  @ViewChild('popover') popover: NgbPopover;
  @Input() attachments = [];
  @Output() skipNextRowClick = new EventEmitter();
  private closePopover;
  private readonly onDestroy$ = new Subject<void>();

  constructor(private elemRef: ElementRef, private ngZone: NgZone, private fileUploadService: FileUploadService) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window.document, 'click')
        .pipe(
          filter((event: MouseEvent) => !!this.closePopover && !this.elemRef.nativeElement.contains(event.target)),
          takeUntil(this.onDestroy$),
        )
        .subscribe(() => {
          this.ngZone.run(() => {
            this.closePopover();
            this.closePopover = null;
          });
        });
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  openPopover(popover: NgbPopover) {
    popover.open(popover);
    this.skipNextRowClick.emit(null);
    this.closePopover = () => popover.close();
  }

  @HostListener('click')
  clickInsidePopover() {
    this.skipNextRowClick.emit(null);
  }

  openFilePreview(doc) {
    this.fileUploadService.openPreviewPopup(doc);
  }
}
